document.addEventListener('DOMContentLoaded', event => {
    if(window.location.href.includes('/instant-t/') && !window.location.href.includes('#instant-t')){
        setTimeout(() => {
            window.location.href = window.location.href + '#instant-t';
        }, 1000)
    }
});